export const NEARBY_TYPE_LABELS = {
  university: "Universitas",
  school: "Sekolah",
  office: "Kantor",
  hospital: "Rumah Sakit",
  clinic: "Klinik",
  pharmacy: "Apotek",
  supermarket: "Supermarket",
  minimarket: "Minimarket",
  market: "Pasar",
  mall: "Mall",
  station: "Stasiun",
  terminal: "Terminal",
  bus_stop: "Halte",
  restaurant: "Restoran",
  place_of_worship: "Tempat Ibadah",
  bank: "Bank",
  atm: "ATM",
  airport: "Bandara",
  shopping_center: "Pusat Perbelanjaan",
  public_facility: "Fasilitas Umum",
  other: "Lainnya",
};

export const NEARBY_TYPE_OPTIONS = Object.entries(NEARBY_TYPE_LABELS).map(([value, label]) => ({ value, label }));
